export const QUESTIONS = [
  {
    key: "pay_type",
    title: "How are you paid?",
    hint: "This decides which proof of income we ask for.",
    options: [
      { value: "employed", label: "Employed", sub: "I get a payslip" },
      { value: "self_employed", label: "Self-employed", sub: "I file a tax return" },
      { value: "both", label: "Both", sub: "A job and self-employed work" },
    ],
  },
  {
    key: "income_proof",
    title: "How do you want to show your income?",
    hint: "Connecting your bank is quickest. You can upload your payslips instead.",
    options: [
      { value: "bank", label: "Connect my bank", sub: "Takes about a minute, read-only" },
      { value: "payslips", label: "Upload my payslips", sub: "Or your tax calculation if you're self-employed" },
    ],
  },
  {
    key: "shares_rent",
    title: "Will anyone share the rent with you?",
    hint: "For example a partner or friend paying part of the rent.",
    options: [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }],
  },
  {
    key: "has_guarantor",
    title: "Do you have a guarantor?",
    hint: "Someone who agrees to pay the rent if you can't.",
    options: [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }],
  },
  {
    key: "has_pets",
    title: "Do you have any pets?",
    hint: "This property doesn't allow pets. Your answer is shared with the letting agent.",
    options: [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }],
  },
  {
    key: "current_living",
    title: "Where do you live now?",
    hint: "Just so we know what to expect. It doesn't change what we ask for.",
    options: [
      { value: "renting", label: "Renting" },
      { value: "with_family", label: "With family" },
      { value: "own_home", label: "Own home" },
      { value: "other", label: "Other" },
    ],
  },
];
